import React, { useCallback, useEffect, useState } from "react";
import {
  API,
  fileUpload,
  // get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import MainBody from "../../components/MainBody/MainBody";
import BootstrapTable from "react-bootstrap-table-next";
import { Card, CardContent, CardTitle } from "../../components/ui/card";
import { useOrganization } from "../../lib/context/OrganisationContext";
import {
  capitalizeSingleWord,
  formatNumber,
  padWithLeadingZeros,
} from "../../lib/Misc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faSatelliteDish } from "@fortawesome/free-solid-svg-icons";
import { Button } from "../../components/ui/button";
import Spin from "../../components/Spin";
import CustomTooltip from "../../components/CustomTooltip";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { Badge } from "../../components/ui/badge";
import moment from "moment";
import Confirmation from "../../components/Confirmation";
import CDDLimit from "./CDDLimit";

const CurrentSubscription = ({ expandList = false }) => {
  const [billingData, setBillingData] = useState([]);
  const [planId, setPlanId] = useState();
  const [activePlan, setActivePlan] = useState(null);
  const [amlCtfPlan, setAmlCtfPlan] = useState(null);
  const [cancelAmlCTFPlan, setCancelAmlCTFPlan] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [supportPlanData, setSupportPlanData] = useState();
  const [kycDetail, setKycDetail] = useState();
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);

  const [upcomingInvoice, setUpcomingInvoice] = useState();
  const [infoUpcomingInvoiceModal, setInfoUpcomingInvoiceModal] =
    useState(false);

  const toggleCancel = (amlcftplan = false) => {
    setCancelAmlCTFPlan(amlcftplan);
    setShowCancel(!showCancel);
  };

  const { organizationData, updateOrganizationData } = useOrganization();

  const fetchBillingData = useCallback(async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("organization_id", organizationData?.organizationId);
      const activeRes = await fileUpload(
        API.GET_SUBSCRIPTION_DETAILS,
        formData,
      );
      const active = activeRes.data?.data?.subscriptions[0];
      const supportPlan = activeRes.data?.data?.supportPlan;
      const amlctfPlan = activeRes.data?.data?.amlCtfSubscription[0];
      let all_subscriptions = {
        mainPlan: activeRes.data?.data?.subscriptions,
        aml_ctf_plan: activeRes.data?.data?.amlCtfSubscription,
        add_on_plan: activeRes.data?.data?.addOns,
      };
      // let billingHistory = activeRes.data?.data?.all_subscriptions?.map((item) => {
      let billingHistory = [];
      if (activeRes.data?.data?.subscriptions?.length > 0) {
        billingHistory.push({
          key: "Plan",
        });
        billingHistory.push(
          ...all_subscriptions.mainPlan?.map((item) => {
            return {
              ...item,
              amount: item?.price,
            };
          }),
        );
      }

      if (activeRes.data?.data?.amlCtfSubscription?.length > 0) {
        billingHistory.push({
          key: "AML/CTF Plan",
        });
        billingHistory.push(
          ...all_subscriptions.aml_ctf_plan?.map((item) => {
            return {
              ...item,
              amount: item?.price,
            };
          }),
        );
      }

      if (activeRes.data?.data?.supportPlan) {
        billingHistory.push({
          key: "Support Plan",
        });
        billingHistory.push(
          ...[activeRes.data?.data?.supportPlan]?.map((item) => {
            return {
              ...item,
              subscription_start_date: "-",
              subscription_end_date: "-",
              metadata: {
                name: item?.support_plan,
              },
              amount: item?.support_price,
              tax_price: item?.support_tax_price,
              total_price:
                Number(item?.support_price) + Number(item?.support_tax_price),
              status: "Active",
            };
          }),
        );
      }

      if (activeRes.data?.data?.addOns?.length > 0) {
        billingHistory.push({
          key: "Add Ons",
        });
        billingHistory.push(
          ...all_subscriptions.add_on_plan?.map((item) => {
            return {
              ...item,
              amount: item?.price,
            };
          }),
        );
      }

      setBillingData(billingHistory);
      setActivePlan(active);
      setAmlCtfPlan(amlctfPlan);
      setSupportPlanData(supportPlan);
      setKycDetail(activeRes.data?.data?.kycDetails);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  }, [organizationData?.organizationId]);

  useEffect(() => {
    fetchBillingData();
  }, [fetchBillingData]);

  const columns = [
    {
      headerClasses: THClasses,
      classes: (cell, row) => {
        if (row?.key?.includes("plan-header")) {
          return `${TDClasses} border-r-0`;
        } else {
          return TDClasses;
        }
      },
      dataField: "subscription_start_date",
      text: "Start Date",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: (cell, row) => {
        if (row?.key?.includes("plan-header")) {
          return `${TDClasses} border-r-0`;
        } else {
          return TDClasses;
        }
      },
      dataField: "subscription_end_date",
      text: "End Date",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: (cell, row) => {
        if (row?.key?.includes("plan-header")) {
          return `${TDClasses} border-r-0`;
        } else {
          return TDClasses;
        }
      },
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: (cell, row) => {
        if (row?.key?.includes("plan-header")) {
          return `${TDClasses} border-r-0`;
        } else {
          return TDClasses;
        }
      },
      dataField: "amount",
      text: "Amount",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: (cell, row) => {
        if (row?.key?.includes("plan-header")) {
          return `${TDClasses} border-r-0`;
        } else {
          return TDClasses;
        }
      },
      dataField: "tax_price",
      text: "Tax Amount",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: (cell, row) => {
        if (row?.key?.includes("plan-header")) {
          return `${TDClasses} border-r-0`;
        } else {
          return TDClasses;
        }
      },
      dataField: "total_price",
      text: "Total Amount",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: (cell, row) => {
        if (row?.key?.includes("plan-header")) {
          return `${TDClasses} border-r-0`;
        } else {
          return TDClasses;
        }
      },
      dataField: "status",
      text: "Status",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: (cell, row) => {
        if (row?.key?.includes("plan-header")) {
          return `${TDClasses} border-r-0`;
        } else {
          return TDClasses;
        }
      },
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      style: { width: "127px" },
    },
  ];

  const billingsGenerator = (quantity) => {
    const items = [];

    for (let i = 0; i < quantity; i++) {
      if (
        billingData[i]?.key === "Plan" ||
        billingData[i]?.key === "AML/CTF Plan" ||
        billingData[i]?.key === "Support Plan" ||
        billingData[i]?.key === "Add Ons"
      ) {
        items.push({
          key: `plan-header-${i}`,
          subscription_start_date: billingData[i]?.key,
          subscription_end_date: "",
          name: "",
          amount: "",
          tax_price: "",
          total_price: "",
          status: "",
          action: <></>,
        });
      } else {
        items.push({
          key: billingData[i]?.id,
          subscription_start_date: billingData[i]?.subscription_start_date
            ? billingData[i]?.subscription_start_date
            : "-",
          subscription_end_date: billingData[i]?.subscription_end_date
            ? billingData[i]?.subscription_end_date
            : "-",
          name: billingData[i]?.metadata?.name
            ? billingData[i]?.metadata?.name
            : "-",
          amount: billingData[i]?.amount
            ? `$${billingData[i]?.amount}`
            : "$0.00",
          tax_price: billingData[i]?.tax_price
            ? `$${billingData[i]?.tax_price}`
            : "$0.00",
          total_price: billingData[i]?.total_price
            ? `$${billingData[i]?.total_price}`
            : "$0.00",
          status: billingData[i]?.status
            ? `${capitalizeSingleWord(billingData[i]?.status)}`
            : "-",
          action: (
            <>
              <span className="flex items-center gap-2 justify-center">
                {billingData[i]?.invoice_url && (
                  <CustomTooltip message={"View Invoice"}>
                    <a
                      href={billingData[i]?.invoice_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-sm btn-outline-primary"
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </a>
                  </CustomTooltip>
                )}
                {billingData[i]?.invoice_url &&
                  billingData[i]?.status !== "canceled" &&
                  billingData[i]?.support_plan !==
                    "Quickstart Onboarding Service" && <span>/</span>}
                {billingData[i]?.status !== "canceled" &&
                  billingData[i]?.support_plan !==
                    "Quickstart Onboarding Service" && (
                    <CustomTooltip message={"Upcoming Invoice"}>
                      <span>
                        <FontAwesomeIcon
                          icon={faSatelliteDish}
                          size="1x"
                          onClick={() => {
                            toggleUpcomingInvoiceList();
                            setPlanId(billingData[i]?.price_id);
                          }}
                        />
                      </span>
                    </CustomTooltip>
                  )}
              </span>
            </>
          ),
        });
      }
    }
    return items;
  };

  const billings = billingsGenerator(billingData?.length);

  const cancelSubscription = async () => {
    const formData = new FormData();
    formData.append("organization_id", organizationData?.organizationId);
    formData.append("is_aml_ctf", cancelAmlCTFPlan ? 1 : 0);
    try {
      setCancelLoading(true);
      let { data } = await fileUpload(`${API.CANCEL_SUBSCRIPTION}`, formData);
      updateOrganizationData(data?.organization);
      fetchBillingData();
      setCancelLoading(false);
    } catch (error) {
      setCancelLoading(false);
    }
  };

  // *API For Fetching the Upcoming invoice details - Start
  const fetchUpcomingInvoice = useCallback(
    async (id) => {
      try {
        setLoading2(true);
        const formData = new FormData();
        if (organizationData?.organizationId) {
          formData.append("organization_id", organizationData?.organizationId);
        }
        formData.append("price_id", id);
        formData.append("quantity", 1);
        const { data } = await fileUpload(API.GET_UPCOMING_INVOICE, formData);
        if (data) {
          setLoading2(false);
          setUpcomingInvoice(data.data);
        } else {
          setLoading2(false);
          setUpcomingInvoice();
        }
      } catch (error) {
        setLoading2(false);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [organizationData?.organizationId],
  );

  useEffect(() => {
    if (infoUpcomingInvoiceModal && planId) {
      fetchUpcomingInvoice(planId);
    }
  }, [planId, fetchUpcomingInvoice, infoUpcomingInvoiceModal]);

  const toggleUpcomingInvoiceList = () => {
    if (infoUpcomingInvoiceModal) {
      setPlanId();
    }
    setInfoUpcomingInvoiceModal(!infoUpcomingInvoiceModal);
  };

  const dollarNumberFormat = (data) => {
    if (Number(data) < 0) {
      return `-$${formatNumber(Math.abs(Number(data)))}`;
    } else {
      return `$${formatNumber(Math.abs(Number(data)))}`;
    }
  };

  const viewJournalDataGenerator = (quantity) => {
    const items = [];
    let mainData = upcomingInvoice?.lines?.data;
    let discountTotalValue = 0;
    let SubTotalValue = 0;
    let TaxValue = 0;
    let TotalValue = 0;

    let planSubTotal = 0;
    let planTaxValue = 0;
    let planDiscountValue = 0;
    let planTotalValue = 0;
    // let lastItem = 0;

    for (let i = 0; i < quantity; i++) {
      SubTotalValue = SubTotalValue + Number(mainData[i]?.amount / 100);
      TaxValue = TaxValue + Number(mainData[i]?.taxes[0]?.amount / 100);
      discountTotalValue =
        discountTotalValue +
        Number(mainData[i]?.discount_amounts?.[0]?.amount / 100);
      TotalValue =
        TotalValue +
        (Number(mainData[i]?.amount / 100) +
          Number(mainData[i]?.taxes[0]?.amount / 100));

      var startDate = new Date(Number(mainData[i]?.period?.start) * 1000);
      var formattedStartDate =
        padWithLeadingZeros(Number(startDate.getUTCDate()), 2) +
        "-" +
        padWithLeadingZeros(Number(startDate.getUTCMonth() + 1), 2) +
        "-" +
        startDate.getUTCFullYear();
      var endDate = new Date(Number(mainData[i]?.period?.end) * 1000);
      var formattedEndDate =
        padWithLeadingZeros(Number(endDate.getUTCDate()), 2) +
        "-" +
        padWithLeadingZeros(Number(endDate.getUTCMonth() + 1), 2) +
        "-" +
        endDate.getUTCFullYear();

      let planSubTotalCalc = 0;

      planSubTotal = Number(planSubTotal) + Number(planSubTotalCalc);

      let planTaxCalc = 0;

      planTaxValue = Number(planTaxValue) + Number(planTaxCalc);

      let planDiscountCalc = 0;

      planDiscountValue = Number(planDiscountValue) + Number(planDiscountCalc);

      let planTotalCalc = 0;

      planTotalValue = Number(planTotalValue) + Number(planTotalCalc);

      items.push({
        key: mainData[i]?.id,
        start_date: formattedStartDate ? formattedStartDate : "-",
        end_date: formattedEndDate ? formattedEndDate : "-",
        description: mainData[i]?.description ? mainData[i]?.description : "-",
        plan_sub_total: planSubTotalCalc
          ? dollarNumberFormat(Number(planSubTotalCalc))
          : "-",
        plan_gst: planTaxCalc ? dollarNumberFormat(Number(planTaxCalc)) : "-",
        plan_discount: planDiscountCalc
          ? dollarNumberFormat(Number(planDiscountCalc))
          : "-",
        plan_total: planTotalCalc
          ? dollarNumberFormat(Number(planTotalCalc))
          : "-",
        sub_total: mainData[i]?.amount
          ? dollarNumberFormat(Number(mainData[i]?.amount / 100))
          : "$0.00",
        tax: mainData[i]?.taxes[0]?.amount
          ? dollarNumberFormat(Number(mainData[i]?.taxes[0]?.amount / 100))
          : "$0.00",
        discount: mainData[i]?.discount_amounts?.[0]?.amount
          ? dollarNumberFormat(
              Number(mainData[i]?.discount_amounts?.[0]?.amount / 100),
            )
          : "$0.00",
        total_amount: mainData[i]?.amount
          ? dollarNumberFormat(
              Number(mainData[i]?.amount / 100) +
                Number(mainData[i]?.taxes[0]?.amount / 100),
            )
          : 0,
      });

      if (i === quantity - 1) {
        items.push({
          description: (
            <div style={{ textAlign: "right" }}>
              <strong>Prorated amlount to be added in the next invoice:</strong>
            </div>
          ),
          sub_total: (
            <strong>{dollarNumberFormat(Number(SubTotalValue))}</strong>
          ),
          tax: <strong>{dollarNumberFormat(Number(TaxValue))}</strong>,
          discount: (
            <strong>
              {discountTotalValue
                ? dollarNumberFormat(Number(discountTotalValue))
                : "$0.00"}
            </strong>
          ),
          total_amount: (
            <strong>{dollarNumberFormat(Number(TotalValue))}</strong>
          ),
        });
      }
    }
    return items;
  };
  const viewJournalData = viewJournalDataGenerator(
    upcomingInvoice?.lines?.data?.length,
  );

  const viewColumns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "start_date",
      text: "Start Date",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "end_date",
      text: "End Date",
    },

    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "description",
      text: "Description",
    },

    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "sub_total",
      text: "Sub Total",
      headerStyle: {
        textAlign: "right",
      },
      style: {
        textAlign: "right",
      },
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "tax",
      text: "Tax",
      headerStyle: {
        textAlign: "right",
      },
      style: {
        textAlign: "right",
      },
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "discount",
      text: "Discount",
      headerStyle: {
        textAlign: "right",
      },
      style: {
        textAlign: "right",
      },
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "total_amount",
      text: "Amount",
      headerStyle: {
        textAlign: "right",
      },
      style: {
        textAlign: "right",
      },
    },
  ];

  // *API For Fetching the Upcoming invoice details - End

  if (loading) return <Spin expand={true} />;

  const rowClasses = (row, rowIndex) => {
    if (row?.key?.includes("plan-header")) {
      return `${TRClasses} bg-webSecondary text-white hover:bg-webSecondary dark:hover:bg-webSecondary`;
    } else {
      return TRClasses;
    }
  };

  return (
    <MainBody
      search={false}
      expandList={expandList}
      loading={cancelLoading || loading2}
      className="dark:bg-background bg-background p-0"
    >
      <div
        className={`grid ${
          activePlan && supportPlanData && amlCtfPlan
            ? "2xl:grid-cols-4 lg:grid-cols-2"
            : (activePlan && supportPlanData) ||
                (amlCtfPlan && activePlan) ||
                (amlCtfPlan && supportPlanData)
              ? "2xl:grid-cols-4 md:grid-cols-2"
              : "lg:grid-cols-4 md:grid-cols-2"
        } grid-cols-1 gap-4`}
      >
        {activePlan && (
          <Card
            className={`${(activePlan && supportPlanData) || (amlCtfPlan && activePlan) ? "col-span-1" : "md:col-span-2 lg:col-span-1"} bg-webPrimary text-white rounded-xl p-4 w-full relative overflow-hidden shadow-lg h-[270px]`}
          >
            <div className="flex flex-col justify-between h-full items-start">
              <div className="w-full">
                <div className="flex justify-between items-center mb-2">
                  <div className="text-xl font-semibold">
                    {activePlan?.metadata.name}
                  </div>
                  <div className="flex items-center gap-3">
                    <Badge
                      variant="secondary"
                      className="text-webPrimary bg-white text-sm"
                    >
                      {activePlan?.interval && "Monthly"}
                    </Badge>
                  </div>
                </div>

                {activePlan?.next_payment_date ? (
                  <div className="text-sm text-gray-200 mb-4">
                    Next Billing{" "}
                    {moment(
                      activePlan?.next_payment_date,
                      "DD-MM-YYYY",
                    )?.format("DD MMM, YYYY")}
                  </div>
                ) : (
                  <></>
                )}

                <CardContent className="p-0 space-y-4 text-white">
                  <div className="mb-4">
                    <div className="flex items-center gap-2">
                      <div>Price: </div>
                      <div className="text-lg font-bold">
                        ${formatNumber(Number(activePlan?.price))}
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <div>Tax Price: </div>
                      <div className="text-lg font-bold">
                        ${formatNumber(Number(activePlan?.tax_price))}
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <div>Total Price: </div>
                      <div className="text-lg font-bold">
                        ${formatNumber(Number(activePlan?.total_price))}
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <div>Status: </div>
                      <Badge
                        variant="secondary"
                        className={`text-white ${
                          activePlan?.status === "canceled"
                            ? "bg-red-500 hover:bg-red-500"
                            : activePlan?.status === "trialing"
                              ? "bg-yellow-500 hover:bg-yellow-500"
                              : "bg-green-500 hover:bg-green-500"
                        } text-sm`}
                      >
                        {capitalizeSingleWord(activePlan?.status)}
                      </Badge>
                    </div>
                  </div>
                </CardContent>
              </div>

              {activePlan?.status !== "canceled" ? (
                <Button
                  // variant="secondary"
                  onClick={() => toggleCancel(false)}
                  // className="bg-[#1e293b] dark:bg-[#1e293b] text-white"
                  className="bg-red-500 text-white"
                >
                  Unsubscribe
                </Button>
              ) : (
                <></>
              )}
            </div>
          </Card>
        )}

        {amlCtfPlan && (
          <Card
            className={`${(amlCtfPlan && supportPlanData) || (amlCtfPlan && activePlan) ? "col-span-1" : "md:col-span-2 lg:col-span-1"} bg-webSecondary text-white rounded-xl p-4 w-full relative overflow-hidden shadow-lg h-[270px]`}
          >
            <div className="flex flex-col justify-between h-full items-start">
              <div className="w-full">
                <div className="flex justify-between items-center mb-2">
                  <div className="text-xl font-semibold">
                    {amlCtfPlan?.metadata?.name}
                  </div>
                  <div className="flex items-center gap-3">
                    <Badge
                      variant="secondary"
                      className="text-webPrimary bg-white text-sm"
                    >
                      {amlCtfPlan?.interval === "month" ||
                      amlCtfPlan?.interval === "aml_month"
                        ? "Monthly"
                        : "Yearly"}
                    </Badge>
                  </div>
                </div>

                {amlCtfPlan?.next_payment_date ? (
                  <div className="text-sm text-gray-200 mb-4">
                    Next Billing{" "}
                    {moment(
                      amlCtfPlan?.next_payment_date,
                      "DD-MM-YYYY",
                    )?.format("DD MMM, YYYY")}
                  </div>
                ) : (
                  <></>
                )}

                <CardContent className="p-0 space-y-4 text-white">
                  <div className="mb-4">
                    <div className="flex items-center gap-2">
                      <div>Price: </div>
                      <div className="text-lg font-bold">
                        ${formatNumber(Number(amlCtfPlan?.price))}
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <div>Tax Price: </div>
                      <div className="text-lg font-bold">
                        ${formatNumber(Number(amlCtfPlan?.tax_price))}
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <div>Total Price: </div>
                      <div className="text-lg font-bold">
                        ${formatNumber(Number(amlCtfPlan?.total_price))}
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <div>Status: </div>
                      <Badge
                        variant="secondary"
                        className={`text-white ${
                          amlCtfPlan?.status === "canceled"
                            ? "bg-red-500 hover:bg-red-500"
                            : amlCtfPlan?.status === "trialing"
                              ? "bg-yellow-500 hover:bg-yellow-500"
                              : "bg-green-500 hover:bg-green-500"
                        } text-sm`}
                      >
                        {capitalizeSingleWord(amlCtfPlan?.status)}
                      </Badge>
                    </div>
                  </div>
                </CardContent>
              </div>

              {amlCtfPlan?.status !== "canceled" ? (
                <Button
                  // variant="secondary"
                  onClick={() => toggleCancel(true)}
                  // className="bg-[#1e293b] dark:bg-[#1e293b] text-white"
                  className="bg-red-500 text-white"
                >
                  Unsubscribe
                </Button>
              ) : (
                <></>
              )}
            </div>
          </Card>
        )}

        {supportPlanData && (
          <Card className="bg-webSecondary2 text-white rounded-xl p-4 w-full relative overflow-hidden shadow-lg h-[230px]">
            <div className="flex flex-col justify-between h-full items-start">
              <div>
                <div className="flex justify-between items-center mb-2">
                  <div className="text-xl font-semibold">
                    {supportPlanData?.support_plan}
                  </div>
                </div>

                <CardContent className="p-0 space-y-4 text-white">
                  <div className="mb-4">
                    <div className="flex items-center gap-2">
                      <div>Price: </div>
                      <div className="text-lg font-bold">
                        ${formatNumber(Number(supportPlanData?.support_price))}
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <div>Tax Price: </div>
                      <div className="text-lg font-bold">
                        $
                        {formatNumber(
                          Number(supportPlanData?.support_tax_price),
                        )}
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <div>Total Price: </div>
                      <div className="text-lg font-bold">
                        $
                        {formatNumber(
                          Number(
                            Number(supportPlanData?.support_price) +
                              Number(supportPlanData?.support_tax_price),
                          ),
                        )}
                      </div>
                    </div>
                  </div>
                </CardContent>
              </div>

              {/* <Button
                variant="destructive"
                onClick={() => cancelSubscription()}
                className="bg-red-500 dark:bg-red-500"
              >
                Unsubscribe
              </Button> */}
            </div>
          </Card>
        )}

        {kycDetail && <CDDLimit
          visualUsed={kycDetail?.visual?.used}
          visualLimit={kycDetail?.visual?.total}
          used={kycDetail?.kyc?.used}
          limit={kycDetail?.kyc?.total}
          kybUsed={kycDetail?.kyb?.used}
          kybLimit={kycDetail?.kyb?.total}
        />}

        {billingData?.length > 0 && (
          <div
            className={`2xl:mt-0 mt-2 ${
              activePlan && supportPlanData && amlCtfPlan
                ? "2xl:col-span-4 lg:col-span-2"
                : activePlan && supportPlanData
                  ? "md:col-span-2"
                  : "md:mt-0 lg:col-span-3 md:col-span-2"
            }`}
          >
            <CardTitle className="my-3 mt-0">Billing History</CardTitle>
            <div className="custom-table">
              <div className={"table-body-class"}>
                <BootstrapTable
                  keyField="id"
                  data={billings ? billings : []}
                  columns={columns}
                  noDataIndication="No billing history found"
                  rowClasses={rowClasses}
                  classes={TableClasses}
                  wrapperClasses={TableWrapClasses}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      {/* <CardTitle className="mb-3">Current Subscription</CardTitle>
      {activePlan ? (
        <div className="card">
          <div className="card-body grid grid-cols-2">
            <div>
              <h5 className="font-bold text-xl text-webPrimary mb-2">
                {activePlan?.metadata.name}
              </h5>
              <div className="flex flex-wrap gap-x-2">
                <div>
                  <strong>Price:</strong> $
                  {formatNumber(Number(activePlan?.price))}
                </div>
                <div>
                  <strong>Tax Price:</strong> $
                  {formatNumber(Number(activePlan?.tax_price))}
                </div>
                <div>
                  <strong>Total Price:</strong> $
                  {formatNumber(Number(activePlan?.total_price))}/
                  {activePlan?.interval}
                </div>
              </div>
              <strong>Status:</strong>{" "}
              {capitalizeSingleWord(activePlan?.status)}
              <br />
              {activePlan?.next_payment_date && (
                <>
                  <strong>Next Billing:</strong> {activePlan?.next_payment_date}
                </>
              )}
            </div>
            {activePlan?.status !== "canceled" && (
              <div className="flex justify-end">
                <Button
                  variant="destructive"
                  onClick={() => cancelSubscription()}
                >
                  Unsubscribe
                </Button>
              </div>
            )}
          </div>
        </div>
      ) : (
        <p>No active subscription found.</p>
      )}
      {supportPlanData && (
        <>
          <CardTitle className="my-3">
            {supportPlanData?.support_plan}
          </CardTitle>
          <div className="card">
            <div className="card-body grid grid-cols-2">
              <div>
                <div className="flex flex-wrap gap-x-2">
                  <p className="card-text">
                    <strong>Price:</strong> $
                    {formatNumber(Number(supportPlanData?.support_price))}
                  </p>
                  <p className="card-text">
                    <strong>Tax Price:</strong> $
                    {formatNumber(Number(supportPlanData?.support_tax_price))}
                  </p>
                  <p className="card-text">
                    <strong>Total Price:</strong> $
                    {formatNumber(
                      Number(supportPlanData?.support_price) +
                        Number(supportPlanData?.support_tax_price)
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      )} */}
      {showCancel && (
        <Confirmation
          title={"Confirmation!"}
          open={showCancel}
          setOpen={setShowCancel}
          toggleShow={() => {
            toggleCancel();
          }}
          className="sm:max-w-fit"
          message={`Do you want to unsubscribe from this plan?`}
          okAction={async () => {
            await cancelSubscription();
            toggleCancel();
          }}
          loading={cancelLoading}
          cancelAction={() => {
            toggleCancel();
          }}
        />
      )}

      {infoUpcomingInvoiceModal && !loading2 && (
        <ResponsiveDrawerForm
          description={""}
          title={"Upcoming Invoice"}
          handleOpen={() => {}}
          handleClose={() => {
            setInfoUpcomingInvoiceModal(false);
            setPlanId();
          }}
          className={"md:w-[90vw]"}
          open={infoUpcomingInvoiceModal}
          buttonClassName={""}
          setOpen={setInfoUpcomingInvoiceModal}
          read={true}
        >
          <div className="custom-table">
            <div className={"table-body-class w-full"}>
              <BootstrapTable
                keyField="key"
                data={viewJournalData}
                columns={viewColumns}
                noDataIndication="No Data Found"
                rowClasses={TRClasses}
                classes={TableClasses}
                wrapperClasses={TableWrapClasses}
              />
            </div>
          </div>
        </ResponsiveDrawerForm>
      )}
    </MainBody>
  );
};

export default CurrentSubscription;
